import React from "react";
import { connect } from "react-redux";
import {
  Spinner,
  SpinnerSize,
  SelectionMode,
  Button,
  FocusZone,
  DetailsList,
  DetailsRow,
  Dropdown,
  ButtonType,
  PrimaryButton,
} from "office-ui-fabric-react";

import LeadForm from "./common/LeadForm";
import axios from "axios";
import config from "../config";
import InfiniteScroll from "react-infinite-scroller";
import StatusBar from "./common/StatusBar";
import { LEAD_REPORT_COLUMNS } from "../constants/tableConfig";

export class Lead extends React.Component {
  constructor(props) {
    super(props);
    this.forms = {};
    this.div = {};

    this.limit = 100;
    this.state = {
      searchText: "",
      customers: [],
      isLoading: false,
      hasMore: true,
      total: 0,
      filterYearStart: 0,
      filterYearEnd: 0,
      filterDoctorHappy: "all",
      isDownloading: false,
      dateRangeOptions: (() => {
        var result = [];
        for (var i = 1900; i <= new Date().getFullYear(); i++) {
          result.push({
            text: i.toString(),
            key: i,
          });
        }
        return result;
      })(),
    };

    this.handleGetColumnConfig = this.handleGetColumnConfig.bind(this);
  }

  componentDidMount() {
    axios.get(`${config.apiUrl}/zipcode/ofme`).then(({ data }) => {
      this.setState({
        zipCodes: data,
        newCustomer: {
          processResults: "LE",
          zipCode: (data[0] || {}).key,
        },
      });
    });

    //Fix issue about tabindx.
    this.FocusZoomKeyDown = FocusZone.prototype._onKeyDownCapture;
    FocusZone.prototype._onKeyDownCapture = function () {};
    this.fetch("", 0, () => {
      if (null != this.props.location) {
        var id = this.props.location.query.id;
        if (id) {
          axios.get(`${config.apiUrl}/customer/get/${id}`).then(({ data }) => {
            var f = this.state.customers.find((c) => c._id == data._id);
            if (!f) {
              var customers = this.state.customers.concat([data]);
              f = data;
              this.setState({
                customers: customers,
              });
            }
            setTimeout(() => {
              this.selectItem(f);
            }, 500);
          });
        }
      }
    });
  }

  componentWillUnmount() {
    FocusZone.prototype._onKeyDownCapture = this.FocusZoomKeyDown;
  }

  componentWillReceiveProps(newPops) {
    this.setState({
      customers: [],
      hasMore: true,
    });
    this.fetch(newPops.searchBox, 0);
  }

  downloadCSV() {
    this.setState({
      isDownloading: true,
    });
    axios
      .get(`${config.apiUrl}/customer/export-data-lead`, {
        params: {
          process: "LE",
          filterYearStart: this.state.filterYearStart,
          filterYearEnd: this.state.filterYearEnd,
          doctorHappy:
            this.state.filterDoctorHappy == true ||
            this.state.filterDoctorHappy == false
              ? this.state.filterDoctorHappy
              : undefined,
        },
      })
      .then(({ data }) => {
        this.setState({
          isDownloading: false,
        });
        window.open(location.origin + data.fileName);
      })
      .catch((ex) => {
        alert("Cannot download " + ex.toString());
        this.setState({
          isDownloading: false,
        });
      });
  }

  fetch(text, skip, cb) {
    if (this.state.isLoading) {
      return;
    }
    this.setState({
      isLoading: true,
    });
    axios
      .get(`${config.apiUrl}/customer/list`, {
        params: {
          limit: this.limit,
          skip: skip != undefined ? skip : this.state.customers.length,
          process: "LE",
          filterYearStart: this.state.filterYearStart,
          filterYearEnd: this.state.filterYearEnd,
          doctorHappy:
            this.state.filterDoctorHappy == true ||
            this.state.filterDoctorHappy == false
              ? this.state.filterDoctorHappy
              : undefined,
        },
      })
      .then(({ data }) => {
        var newCustomers = data.filter(
          (e) => !this.state.customers.find((c) => c._id == e._id)
        );
        var customers = this.state.customers.concat(newCustomers);
        this.setState({
          customers: customers,
          isLoading: false,
          hasMore: newCustomers.length >= this.limit,
        });
        cb && cb();
      })
      .catch((ex) => {
        this.setState({
          isLoading: false,
          hasMore: false,
        });
        cb && cb();
      });

    axios
      .get(`${config.apiUrl}/customer/count`, {
        params: {
          process: "LE",
          filterYearStart: this.state.filterYearStart,
          filterYearEnd: this.state.filterYearEnd,
          doctorHappy:
            this.state.filterDoctorHappy == true ||
            this.state.filterDoctorHappy == false
              ? this.state.filterDoctorHappy
              : undefined,
        },
      })
      .then(({ data }) => {
        this.setState({
          total: data.total,
        });
      })
      .catch((ex) => {});
  }

  changeFilterYear(start, end) {
    this.setState(
      {
        filterYearStart: start,
        filterYearEnd: end,
        customers: [],
        hasMore: true,
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }
  changeFilterDoctorHappy(v) {
    this.setState(
      {
        filterDoctorHappy: v.key,
        customers: [],
        hasMore: true,
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }

  selectItem(e) {
    try {
      var selection = window.getSelection();
      if (selection.toString().length > 0) {
        return;
      }
    } catch (ex) {}

    if (this.selectedItem != e) {
      this.tmpSelectedItem &&
        this.resetBgDiv(this.div[this.tmpSelectedItem._id]);
      this.selectedItem && this.resetBgDiv(this.div[this.selectedItem._id]);
      this.selectedItem && this.forms[this.selectedItem._id].hide();
      this.forms[e._id].show();
      this.changeBgDiv(this.div[e._id]);
      this.scrollY = window.scrollY;
      this.selectedItem = e;
      this.tmpSelectedItem = null;
      window.history.replaceState("", "", "/lead-report?id=" + e._id);
    } else {
      this.selectedItem && this.resetBgDiv(this.div[this.selectedItem._id]);
      this.selectedItem && this.forms[this.selectedItem._id].hide();
      this.selectedItem = null;
      this.tmpSelectedItem = null;
      window.history.replaceState("", "", "/lead-report");
    }

    this.forceUpdate();
  }

  hiddenForm(e) {
    if (e == this.selectedItem) {
      this.selectedItem && this.forms[e._id].hide();
      // this.selectedItem && this.resetBgDiv(this.div[e._id])
      this.tmpSelectedItem = this.selectedItem;
      // this.scrollToItem(e);
      this.backToPossitionScroll();
      this.selectedItem = null;
      window.history.replaceState("", "", "/lead-report");
    }
  }

  backToPossitionScroll() {
    window.scrollTo(0, this.scrollY);
  }

  scrollToItem(e) {
    var div = this.div[e._id];
    div.scrollIntoView();
    window.scrollTo(0, window.scrollY - 100);
  }

  resetBgDiv(div) {
    div.style.background = "";
  }

  changeBgDiv(div) {
    div.style.background = "#f0f0f0";
  }

  print(e, evt) {
    evt && evt.stopPropagation && evt.stopPropagation();
    var url =
      config.apiUrl +
      "/customer/pdf/" +
      e._id +
      "?token=" +
      this.props.auth.user.token;
    var win = window.open(url);
    win.focus();
  }

  handleGetColumnConfig() {
    const { auth } = this.props;
    let columns = LEAD_REPORT_COLUMNS;

    if (_.get(auth, "user.accountType") !== "staff") {
      columns = columns.slice(1);
    }
    return columns.map((col) => {
      if (col.key === "process") {
        return {
          ...col,
          onRender: (item) => {
            return (
              <div>
                <button
                  className="tbl-btn"
                  onClick={(e) => this.print(item, e)}
                >
                  <i className="ms-Icon ms-Icon--Print" aria-hidden="true"></i>
                </button>
              </div>
            );
          },
        };
      }

      return col;
    });
  }

  render() {
    const {
      isLoading,
      hasMore,
      customers,
      filterDoctorHappy,
      total,
    } = this.state;
    const columns = this.handleGetColumnConfig();

    // render HTML
    return (
      <div style={{ margin: 10 }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div style={{ width: 200 }} className="one-line-100">
              <Dropdown
                label="Doctor Happy"
                selectedKey={filterDoctorHappy}
                options={[
                  { key: "all", text: "--" },
                  { key: true, text: "YES" },
                  { key: false, text: "NO" },
                ]}
                onChanged={(v) => this.changeFilterDoctorHappy(v)}
              />
            </div>
            <div
              style={{ width: 180, marginLeft: 50 }}
              className="one-line-100"
            >
              <Dropdown
                label="Year of Birth"
                selectedKey={this.state.filterYearStart}
                options={[{ key: 0, text: "--" }].concat(
                  this.state.dateRangeOptions
                )}
                onChanged={(v) =>
                  this.changeFilterYear(
                    v.key < this.state.filterYearEnd ||
                      v.key === 0 ||
                      this.state.filterYearEnd == 0
                      ? v.key
                      : this.state.filterYearStart,
                    this.state.filterYearEnd
                  )
                }
              />
            </div>
            <div style={{ width: 130, marginLeft: 20 }} className="one-line-50">
              <Dropdown
                label="to"
                style={{ width: 100 }}
                selectedKey={this.state.filterYearEnd}
                options={[{ key: 0, text: "--" }].concat(
                  this.state.dateRangeOptions
                )}
                onChanged={(v) =>
                  this.changeFilterYear(
                    this.state.filterYearStart,
                    v.key > this.state.filterYearStart ||
                      v.key == 0 ||
                      this.state.filterYearStart == 0
                      ? v.key
                      : this.state.filterYearEnd
                  )
                }
              />
            </div>
          </div>
          <PrimaryButton onClick={() => this.downloadCSV()}>
            {this.state.isDownloading ? (
              <Spinner key={1} size={SpinnerSize.large} />
            ) : (
              "Download CSV"
            )}
          </PrimaryButton>
        </div>
        <InfiniteScroll
          pageStart={0}
          loadMore={() => this.fetch()}
          useWindow={true}
          initialLoad={false}
          style={{ marginBottom: 30 }}
          loader={
            isLoading ? (
              <Spinner key={1} size={SpinnerSize.large} />
            ) : (
              <span key={2}></span>
            )
          }
          hasMore={hasMore}
        >
          <DetailsList
            setKey={"_id"}
            items={customers}
            columns={columns}
            selectionPreservedOnEmptyClick={true}
            selectionMode={SelectionMode.none}
            onRenderRow={(props) => {
              return (
                <div style={{ borderBottom: "1px solid #e6e6e6" }}>
                  <div
                    ref={(e) => (this.div[props.item._id] = e)}
                    onClick={() => this.selectItem(props.item)}
                    className="row-hover"
                  >
                    <DetailsRow {...props} />
                  </div>
                  <LeadForm
                    ref={(e) => (this.forms[props.item._id] = e)}
                    data={props.item}
                    onCancel={() => this.hiddenForm(props.item)}
                  />
                </div>
              );
            }}
          />
        </InfiniteScroll>
        <StatusBar>
          <span>Total: {total}</span>
          {this.selectedItem && (
            <span>
              {" "}
              | Selected: #{customers.indexOf(this.selectedItem) + 1} -{" "}
              {`${this.selectedItem.firstName} ${this.selectedItem.lastName}`}{" "}
            </span>
          )}
        </StatusBar>
      </div>
    );
  }
}

export default connect((state) => ({
  auth: state.auth,
  searchBox: state.app.searchBox || { filter: "", text: "" },
}))(Lead);



// WEBPACK FOOTER //
// ./client/components/LeadReport.js